import { useEffect, useState } from "react";

export function useActiveTab() {
  const [isActiveTab, setIsActiveTab] = useState(
    document.visibilityState === "visible"
  );

  useEffect(() => {
    const handleVisibility = () => {
      setIsActiveTab(document.visibilityState === "visible");
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  return isActiveTab;
}
